import axios from '@/api/config';

const scoreRule = {
  getScoreRuleById(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRule/` + data, {});
  },
  getScoreRule(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRule`, { params: data });
  },
  getScoreRuleList(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRuleList`, { params: data });
  },
  getScoreRuleTree(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRuleTree`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/scoreRule/pageList`, data);
  },
  addScoreRule(data) {
    return axios.post(`${process.env.BASE_URL}/scoreRule/addScoreRule`, data);
  },
  addScoreRuleItem(data) {
    return axios.post(`${process.env.BASE_URL}/scoreRule/addScoreRuleItem`, data);
  },
  updateScoreRule(data) {
    return axios.put(`${process.env.BASE_URL}/scoreRule/updateScoreRule`, data);
  },
  deleteScoreRule(data) {
    return axios.delete(`${process.env.BASE_URL}/scoreRule/deleteScoreRule`, { data: data });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/exportExcel`, { params: data });
  },
  scoreRuleItemList(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/scoreRuleItemList`, { params: data });
  },
  getCourseScoreRuleTree(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getCourseScoreRuleTree`, { params: data });
  },
  getScoreRuleByIdsss(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRuleById`, { params: data });
  },
  scoreRuleItemById(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/scoreRuleItemById`, { params: data });
  },
  getScoreRuleSelectListByCourse(data) {
    return axios.get(`${process.env.BASE_URL}/scoreRule/getScoreRuleSelectListByCourse`, { params: data });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/scoreRule/importData`, data);
  },
  updateScoreRuleItem(data) {
    return axios.put(`${process.env.BASE_URL}/scoreRule/updateScoreRuleItem`, data);
  }
}

export default scoreRule;



// WEBPACK FOOTER //
// ./src/api/scoreRule.js